<template>
  <div class="valuations-images-container">
    <div v-if="svVisible">
      <div v-if="positionerror" class="msgnotfound">
        {{ $t('streeview-not-image') }}
      </div>
      <div v-if="!positionerror" class="street-view-valuations-image street-view-valuations-image--1">
        <div :id="googleStreeViewId(1)" ref="streetView1" class="googleStreeViewContainer" />
      </div>
      <div v-if="!positionerror" class="street-view-valuations-image street-view-valuations-image--2">
        <div :id="googleStreeViewId(2)" ref="streetView2" class="googleStreeViewContainer" />
      </div>
    </div>
    <div v-else class="position-not-selected">
      {{ $t('position-not-selected') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { gmapApi } from 'gmap-vue'
export default {
  name: 'StreetViewImages',
  components: {},
  data() {
    return {
      svVisible: false,
      positionerror: false,
      camaraDirection: 270,
      camaraDirection2: 90
    }
  },
  computed: {
    ...mapState('location', {
      position: (state) => state.position
    }),
    google: gmapApi
  },
  watch: {
    position: function() {
      console.log('position change')
      this.initView()
    }
  },
  activated() {
    console.log('activated')
    this.initView()
  },
  mounted() {
    console.log('mounted')
    this.initView()
  },
  methods: {
    googleStreeViewId(id) {
      return 'googleStreetViewContainer-' + Math.floor(Math.random() * (9999 - 0)) + id
    },
    async initView() {
      this.svVisible = true
      this.positionerror = false
      if (this.position.latitude === null || this.position.longitude === null) {
        this.svVisible = false
        return
      }
      var vm = this
      var pos = { lat: this.position.latitude, lng: this.position.longitude }
      await this.$gmapApiPromiseLazy().then(() => {
        const sv = new vm.google.maps.StreetViewService()
        this.panorama = new vm.google.maps.StreetViewPanorama(document.getElementById(vm.$refs.streetView1.id))
        sv.getPanorama(
          {
            location: pos,
            radius: 50,
            source: vm.google.maps.StreetViewSource.OUTDOOR
          },
          vm.processSVData
        )
        this.panorama2 = new vm.google.maps.StreetViewPanorama(document.getElementById(vm.$refs.streetView2.id))
        sv.getPanorama(
          {
            location: pos,
            radius: 50,
            source: vm.google.maps.StreetViewSource.OUTDOOR
          },
          vm.processSVData2
        )
      }).catch(err => {
        this.positionerror = true
        console.error(err)
        // debugger
      })
    },
    processSVData(data, status) {
      if (status === 'OK') {
        var location = data.location
        this.panorama.setPano(location.pano)
        // debugger
        this.panorama.setPov({
          heading: this.camaraDirection,
          pitch: 0
        })
        this.panorama.setVisible(true)
      } else {
        this.positionerror = true
        console.error('Street View data not found for this location.')
      }
    },
    processSVData2(data, status) {
      if (status === 'OK') {
        var location = data.location
        this.panorama2.setPano(location.pano)
        // debugger
        this.panorama2.setPov({
          heading: this.camaraDirection2,
          pitch: 0
        })
        this.panorama2.setVisible(true)
      } else {
        console.error('Street View data not found for this location.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.valuations-images-container {
  height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;

  .street-view-valuations-image {
    height: 50%;
    width: 100%;
    margin-bottom: 10px;
  }
}
.googleStreeViewContainer {
  min-height: 40vh;
  width: 100%;
}
</style>
